import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { TableContent } from './RenderVerification';

export const EditorContentExtension = Node.create({
  name: 'DNSRecordsTable',

  group: 'block',

  atom: true,
  draggable: true,
  parseHTML() {
    return [
      {
        tag: 'tiptap-editor-style',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['tiptap-editor-style', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(TableContent);
  },
});
